type SelectableOption = {
  id?: string;
  value: string;
};

export const getSelectedOptionId = (options: SelectableOption[], selectedValue: string): string =>
  options.find((option) => option.value === selectedValue)?.id ?? selectedValue;
